import { render, staticRenderFns } from "./FixtureListComponent.vue?vue&type=template&id=f8c67e3e&"
import script from "./FixtureListComponent.vue?vue&type=script&lang=js&"
export * from "./FixtureListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports